<div class="md-input-container" fxLayout.xs="column">
    <div>
    <mat-form-field class="mat-form-withtooltip" >
        <mat-label>Team</mat-label>
        <mat-select [(ngModel)]="value" name="manager" (openedChange)="onOpen($event)"
        [compareWith]="objectComparison"
                    #teamsel="ngModel"
                    [required]="isRequired"
        [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''">

            <mat-option *ngIf="items === null" class="minh88" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option [value]="-1" *ngIf="!isLoading">                
            </mat-option>
            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}</mat-option>
        </mat-select>
        <mat-error  class="md-errormsg" *ngIf="!teamsel.valid && teamsel.touched && isRequired">Required</mat-error>
    </mat-form-field>
    <mat-icon fxFlexAlign.lt-md="center" class="ng-scope md-iwgNavbar-theme material-icons" [matTooltip]="'Please select the team, if desired.'" matTooltipPosition="above">
        help
    </mat-icon>
    </div>
    <mat-error  class="sm-errormsg" *ngIf="!teamsel.valid && teamsel.touched && isRequired">Required</mat-error>
</div>

